import propertyListStore from '@modules/property/property-list-store';
import propertyViewStore from '@modules/property/property-view-store';
import propertyImporterStore from '@modules/property/property-importer-store';
import propertyFormStore from '@modules/property/property-form-store';
import propertyDestroyStore from '@modules/property/property-destroy-store';
import propertyDashboardStore from '@modules/property/property-dashboard-store';
import propertyRequirementsStore from '@modules/property/property-requirements-store';
import propertyWalletPageStore from '@modules/property/property-wallet-page-store';

export default {
  namespaced: true,

  modules: {
    requirements: propertyRequirementsStore,
    dashboard: propertyDashboardStore,
    destroy: propertyDestroyStore,
    form: propertyFormStore,
    list: propertyListStore,
    view: propertyViewStore,
    importer: propertyImporterStore,
    wallet: propertyWalletPageStore
  },
};
